/**
 * Hook to set up API authentication with Clerk tokens
 * This should be used once at the app level to configure the API client
 */

import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthTokenGetter } from '../services/api';

export function useApiAuth() {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (isLoaded) {
      // Set up the token getter for the API client
      setAuthTokenGetter(async () => {
        try {
          return await getToken();
        } catch (error) {
          console.error('[useApiAuth] Failed to get token:', error);
          return null;
        }
      });
    }
  }, [getToken, isLoaded]);
}
